import React from "react";
import CiroTextArea from "../../../../../shared/CiroTextArea";
import classNames from "classnames";
import { IPowersearchFieldValueProps } from "./PowersearchFieldValue";
import CiroTooltipContainer from "../../../../../shared/CiroTooltipContainer";

export const PowersearchLinkedinProfileKeywordValueEditor: React.FC<
  IPowersearchFieldValueProps
> = ({ value, handleOnChange, disabled, errorMessage }) => {
  return (
    <div className={classNames("flex", "flex-col", "w-full", "rounded-sm")}>
      <CiroTextArea
        customClassName={classNames("text-xs")}
        value={value || ""}
        onChange={(e) => handleOnChange(e.target.value ? e.target.value : null)}
        placeholder={'(SEO OR "search engine optimization") AND analytics'}
        disabled={disabled}
        error={errorMessage}
      />
      <div className={classNames("flex", "items-center", "justify-end")}>
        <CiroTooltipContainer
          tooltip={
            <div className={classNames("text-xs", "text-gray-500", "mt-1")}>
              Use AND, OR, and parentheses to create complex search expressions.
              <br />
              Example: (SEO OR "search engine optimization") AND analytics
            </div>
          }
        >
          <div className={classNames("text-xs", "text-gray-500", "underline")}>
            Help
          </div>
        </CiroTooltipContainer>
      </div>
    </div>
  );
};

export default PowersearchLinkedinProfileKeywordValueEditor;
